import {
  Component,
  OnInit,
  Input
} from '@angular/core';
import {
  UserService
} from '../user.service';
import {
  NgxSpinnerService
} from "ngx-spinner";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray,
  AbstractControl,
  ValidationErrors,
  FormGroupDirective
} from '@angular/forms';
import {
  HelperService
} from '../helper.service';
import {
  Router
} from "@angular/router";
import {
  CreateAdminComponent
} from '../create-admin/create-admin.component';

@Component({
  selector: 'app-allot-license',
  templateUrl: './allot-license.component.html',
  styleUrls: ['./allot-license.component.css']
})
export class AllotLicenseComponent implements OnInit {
  allotArray = [];
  emptyStoreArray = [];
  emptyAdminArray = [];
  storeExist = true;
  emptyValue: string = "";
  emptyValueAdmin: string = "";
  stateLoading = false;
  storeSelectHistory = [];
  newStore = [];
  PurchasedProducts = [];
  AdminData = [];
  Companies = [];
  countries = [];
  States = [];
  storehide = [];
  adminhide = [];
  timezones = [];
  Storemessage = [];
  Companymessage = [];
  Adminmessage = [];
  selectedCompanies = [];
  Stores = [];
  selectedCompaniesAndstores = [];
  selectedStores = [];
  store_added: string = '';
  Storeimage: string = '';
  primary_color: string = '';
  storeSubmitted = false;
  SubscriptionForm: FormGroup;
  subscriptionData: FormArray;
  successMessage = HelperService.successMessage;
  emptyCompany = true;
  companyId: string = '';
  adminSubmitted = false;
  adminmessage = '';
  emailerror = '';
  userexist: boolean = true;
  selectedAdmins = [];
  licenseCount = null;
  constructor(private fb: FormBuilder, private userService: UserService, private SpinnerService: NgxSpinnerService, private router: Router, private CreateAdminComponent: CreateAdminComponent) {
      this.selectedStoreHistory();
      this.selectedAdminsHistory();


  }

  ngOnInit(): void {
      this.userService.getUserCompanies().subscribe((res) => {
          if (res.companies.length > 0) {
              this.companyId = res.companies[0].company_id;
          } else {
              this.router.navigate(['/company-store']);

          }
      })
      //this.allotHistoryClear();
      this.getStores();
      this.SpinnerService.show();
      this.callSelectedCompanies();
      this.selectStoreExist();
      this.userService.gettimezones().subscribe((data: any) => {
          this.timezones = data;
      });
      this.userService.UserPurchasedProducts().subscribe((res) => {
          //this.SpinnerService.show(); 
          this.PurchasedProducts = res.purchased_products;
          // ////console.log(res.purchased_products);
          for (var i = 0; i < res.purchased_products.length; i++) {
              this.emptyStoreArray[i] = "";
              this.emptyAdminArray[i] = "";
              /* var obj = res.purchased_products[i];
              for (var key in obj){
                //console.log(key);
                  //var attrName = key;
                  //var attrValue = obj[key];
              } */
          }
          this.licenseCount = res.purchased_products.length;
          if (res.purchased_products.length <= 0) {
              this.router.navigate(['/subscriptions']);
          }
          this.registrationForm.setControl('addDynamicElement', this.setExistingStore(res.purchased_products));

          this.userService.getAdminUsers().subscribe((res) => {
              this.AdminData = res.admin_users;
          });



          this.userService.getUserCompanies().subscribe((res) => {
              this.Companies = res.companies;



          })
          //////console.log(this.Companies);

          this.SpinnerService.hide();

      })




      this.userService.getcountries().subscribe((data: any) => {
          this.countries = data.countries;
      })

      this.SubscriptionForm = this.fb.group({
          subscriptionData: this.fb.array([
              this.fb.group({
                  SubscriptionId: [''],
                  company_id: [Validators.required],
                  store_id: ['', Validators.required],
                  admin_id: ['', Validators.required]
              })
          ]),

      });
  }


  getStores() {
      this.userService.getUserStoreList().subscribe((res) => {
          this.Stores = res.stores;
      });
  }
  setExistingStore(skillSets): FormArray {
      const formArray = new FormArray([]);
      skillSets.forEach(s => {
          formArray.push(this.fb.group({
              SubscriptionId: s.id,
              company_id: this.companyId,
              store_id: new FormControl([]),
              admin_id: new FormControl([])

          }));
      });

      return formArray;


  }
  callSelectedCompanies() {
      if (localStorage.getItem('selectedCompanies') !== null) {
          const SelectedCompanies = JSON.parse(localStorage.getItem('selectedCompanies'));
          SelectedCompanies.forEach((value, index) => {
              this.storehide[index] = true
              this.adminhide[index] = true
              this.registrationForm['controls']['addDynamicElement']['controls'][index]['controls'].company_id.patchValue(value);
          });
      }

  }


  store_update = new FormGroup({
      id: new FormControl(''),
      Storeimage: new FormControl(''),
      store_name: new FormControl('', [Validators.required]),
      owner_name: new FormControl('', [Validators.required]),
      contact_number: new FormControl('', [Validators.required]),
      email_Address: new FormControl('', [Validators.required]),
      address_line1: new FormControl('', [Validators.required]),
      country: new FormControl('', [Validators.required]),
      address_line2: new FormControl(''),
      city: new FormControl('', [Validators.required]),
      State: new FormControl('', [Validators.required]),
      zip: new FormControl('', [Validators.required]),
      timezone: new FormControl("", [Validators.required]),
      primary_color: new FormControl(''),
  });

  get store_form() {
      return this.store_update.controls;
  }

  store_submit(event) {
      event.preventDefault();
      this.storeSubmitted = true;
      this.SpinnerService.show();
      // ////console.log(this.store_update.value);
      if (this.store_update.invalid) {
          this.SpinnerService.hide();
          return;
      }
      //////console.log(this.store_update.value);
      const storeData = this.store_update.value;
      const store_id = this.store_update.value.id;
      const store_name = this.store_update.value.store_name;
      const country = this.store_update.value.country;
      const company_id = this.companyId;
      this.userService.addNewStore(storeData, company_id).subscribe(resp => {
          this.SpinnerService.hide();
          //////console.log(resp);
          if (resp.status == 2) {} else {
              this.newStore[resp.store_id] = store_name;
              /* this.getStores();
              this.selectedStoreHistory(); */
              // this.ngOnInit();
              this.store_added = this.successMessage;
              this.resetStoreForm();
              setTimeout(() => {
                  this.store_added = '';
                  const close_store_modal = document.querySelector('.close_store_modal');
                  if (close_store_modal instanceof HTMLElement) {
                      close_store_modal.click();
                  }
                  const currentRoute = this.router.url;
                  /*  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                       //this.router.navigate([currentRoute]); // navigate to same route
                       
                   }); */

                  this.router.navigate([currentRoute])
                      .then(() => {
                          window.location.reload();
                      });

              }, 1000);
          }
      })
  }
  changeStateStore(event) {
      this.stateLoading = true;
      // localStorage.setItem('country.id', event);
      this.userService.getRegions(event).subscribe(res => {
          this.States = res.regions;
          this.stateLoading = false;
      })
      this.store_update.get('State').setValue("");

  }

  handleChangeComplete(event) {
      const primary_color = event;
      this.store_update.get('primary_color').setValue(primary_color);
      ( < HTMLInputElement > document.getElementById("cstm_color_new")).value = event;
      ( < HTMLInputElement > document.getElementById("cstm_color_new")).style.color = event;
      ( < HTMLInputElement > document.getElementById("cstm_color_new")).style.background = event;
      //this.CompanyForm['controls']['StoresArray']['controls'][index]['controls'].primary_color.patchValue(event);
  }
  addStore() {
      this.resetStoreForm();
      //this.addStoreComponent.companyId = this.companyId;
      ////console.log(this.companyId);
      //////console.log(this.addStoreComponent.companyId);
  }
  resetStoreForm() {
      this.Storeimage = null;
      this.storeSubmitted = false;
      //////console.log('addStore');
      this.store_update.reset();
      this.store_update.get('timezone').setValue("");
      this.store_update.get('State').setValue("");
      this.store_update.get('country').setValue("");
      this.store_update.get('primary_color').setValue("");
      ( < HTMLInputElement > document.getElementById("cstm_color_new")).value = "";
      ( < HTMLInputElement > document.getElementById("cstm_color_new")).style.color = "";
      ( < HTMLInputElement > document.getElementById("cstm_color_new")).style.background = "";
  }
  selectImageStore(event) {
      this.SpinnerService.show();
      let file = event.target.files[0];

      // File Preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
          //////console.log(e.target.result);
          this.Storeimage = e.target.result;
          this.store_update.get('Storeimage').patchValue(e.target.result);
          this.SpinnerService.hide();
      }
      reader.readAsDataURL(file)

  }
  updateUrl(event, store_id, index) {
      this.Stores[index]['Storeimage'] = 'assets/images/profiles.png';
  }

  selectStoreExist() {
      if (localStorage.getItem('selectedCompaniesAndstores') !== null) {
          var x = true;
          const StoreData = JSON.parse(localStorage.getItem('selectedCompaniesAndstores'));
          //console.log(StoreData);
          this.storeExist = false;
          StoreData.forEach(function(event) {});
      }
  }

  SelectedStore(event, subId, j) {
      console.log(subId);
      this.callSelectedCompanies();
      //////console.log(j);
      this.Storemessage[j] = '';
      // ////console.log(event);
      if (event !== "") {
          // console.log('not 3 product');
          ////console.log(event, subId, j);
          if (subId == '3') {
              var x = true;
              const combinedCS = event;
              this.Storemessage[j] = '';
              this.userService.checkAllottedStore(event,subId).subscribe((res) => {
                  //console.log(res);
                  if (res.status == 3) {
                      this.storeExist = true;
                      x = false;
                      this.Storemessage[j] = res.msg;
                      this.registrationForm['controls']['addDynamicElement']['controls'][j]['controls'].store_id.patchValue("");
                      return;
                  }

                  if (localStorage.getItem('selectedCompaniesAndstores') !== null) {
                      this.selectedCompaniesAndstores = JSON.parse(localStorage.getItem('selectedCompaniesAndstores'))
                      localStorage.setItem('selectedCompaniesAndstores', JSON.stringify(this.selectedCompaniesAndstores))
                      this.selectedCompaniesAndstores.every((value, index) => {
                          if (value == combinedCS && index !== j) {
                              x = false;
                              this.Storemessage[j] = 'Store already selected';
                              this.registrationForm['controls']['addDynamicElement']['controls'][j]['controls'].store_id.patchValue("");
                              this.selectedCompaniesAndstores[j] = ""
                              localStorage.setItem('selectedCompaniesAndstores', JSON.stringify(this.selectedCompaniesAndstores));
                              return false;
                          } else {
                              this.selectedCompaniesAndstores[j] = combinedCS
                              localStorage.setItem('selectedCompaniesAndstores', JSON.stringify(this.selectedCompaniesAndstores));
                          }
                          return true;
                      });

                  } else {
                      this.selectedCompaniesAndstores[j] = combinedCS
                      localStorage.setItem('selectedCompaniesAndstores', JSON.stringify(this.selectedCompaniesAndstores))
                  }

                  if (x == true) {
                      this.storeExist = false;
                      if (localStorage.getItem('selectedStores') !== null) {

                          this.selectedStores = JSON.parse(localStorage.getItem('selectedStores'));
                          this.selectedStores[j] = event

                          localStorage.setItem('selectedStores', JSON.stringify(this.selectedStores))
                      } else {
                          this.selectedStores[j] = event;
                          localStorage.setItem('selectedStores', JSON.stringify(this.selectedStores));

                      }
                      localStorage.setItem('storeindex', j);
                  }

              });
          }
          else{
            this.userService.checkAllottedStore(event,subId).subscribe((res) => {
              //console.log(res);
              /* if (res.status == 3) {
                  this.storeExist = true;
                  x = false;
                  this.Storemessage[j] = res.msg;
                  this.registrationForm['controls']['addDynamicElement']['controls'][j]['controls'].store_id.patchValue("");
                  return;
              } */
            });

            if (localStorage.getItem('selectedStores') !== null) {
              this.selectedStores = JSON.parse(localStorage.getItem('selectedStores'));
              this.selectedStores[j] = event
              localStorage.setItem('selectedStores', JSON.stringify(this.selectedStores))
            } else {
                this.selectedStores[j] = event;
                localStorage.setItem('selectedStores', JSON.stringify(this.selectedStores));
            }
          }
      } else {
          if (localStorage.getItem('selectedStores') !== null) {
              this.selectedStores = JSON.parse(localStorage.getItem('selectedStores'))
              this.selectedStores[j] = "";
              localStorage.setItem('selectedStores', JSON.stringify(this.selectedStores))
          }
          if (localStorage.getItem('selectedCompaniesAndstores') !== null) {
              this.selectedCompaniesAndstores = JSON.parse(localStorage.getItem('selectedCompaniesAndstores'))
              this.selectedCompaniesAndstores[j] = "";
              localStorage.setItem('selectedCompaniesAndstores', JSON.stringify(this.selectedCompaniesAndstores))
          }
      }
  }


  /*##################### Registration Form #####################*/
  registrationForm = this.fb.group({
      addDynamicElement: this.fb.array([
          this.fb.group({
              SubscriptionId: [''],
              store_id: ['', Validators.required],
              admin_id: ['', Validators.required],
              company_id: [this.companyId, Validators.required],
          })
      ])
  })

  /*############### Add Dynamic Elements ###############*/
  get addDynamicElement() {
      return this.registrationForm.get('addDynamicElement') as FormArray
  }


  // Submit Registration Form
  onSubmit() {
      //console.log(this.companyId);
      var x = true;
      let formData = this.registrationForm.value;
      let data = formData.addDynamicElement;
      var allMatched = true;
      data.every((value, index) => {
          value.company_id = this.companyId;
          if ((value.admin_id == '' && value.store_id != '') || value.admin_id != '' && value.store_id == '') {
              allMatched = false;
              //console.log('one1');
              x = false;
              //return false;
          }
          if (value.company_id != '' && value.admin_id != '' && value.store_id != '') {
              //console.log('two2');
              x = true;
          }

          if (value.company_id == '') {
              x = false;
              this.Storemessage[index] = 'Company is required';
          }
          if (value.store_id == '') {
              x = false;
              this.Storemessage[index] = 'Store is required';
          }

          if (this.storeExist == true) {
              x = false;
          }

          if (value.admin_id == '') {
              //////console.log('empty admin');
              x = false;
              this.Adminmessage[index] = 'Admin is required';
          }

          this.Adminmessage.forEach((value, index) => {

              if (value !== '') {

                  x = false
              }
          })
          return true;
          //console.log(value);
          //console.log(this.Adminmessage);
          //console.log(this.storeExist);
      });
      if (allMatched) {
        let formData = this.registrationForm.value;
        let data = formData.addDynamicElement;
        console.log(formData.addDynamicElement);
        data.forEach((value, index) => {
            //console.log(value);
           // console.log(value.admin_id);
            //console.log(value.store_id);
            if(value.admin_id != '' && value.store_id != ''){
                x = true;
                this.Adminmessage = [];
                this.Storemessage = [];
            }
        });
          /* x = true;
          this.Adminmessage = [];
          this.Storemessage = []; */
      }
      /* //console.log(x);
      //console.log(data);
      return ; */
      /* console.log(data);
      console.log(data[0].store_id);
      console.log(x);
      return false; */
      if (x) {
          this.SpinnerService.show();
          this.userService.updateCustomerSubscription(this.registrationForm.value).subscribe((res) => {
              if (res.status == 1) {
                  this.allotHistoryClear();
                  this.SpinnerService.hide();
                  this.router.navigate(['/subscriptions']);
              }
          });
      } else {
          // ////console.log(this.registrationForm.value)
      }
  }

  checkFormValid(admin_user_id, productid, j) {


      this.Adminmessage[j] = '';
      if (admin_user_id !== '') {
          var x = true;

          if (productid == 3) {
              this.userService.validateAdminUser(admin_user_id, productid).subscribe((res => {

                  if (res.status == 3) {
                      this.Adminmessage[j] = "Admin already assigned";
                      x = false;
                      this.userexist = false;
                      this.registrationForm['controls']['addDynamicElement']['controls'][j]['controls'].admin_id.patchValue("");
                      return;
                  }
                  if (x == true) {
                      if (localStorage.getItem('selectedAdmins') == null) {
                          //console.log('admin1');
                          this.selectedAdmins[j] = admin_user_id
                          localStorage.setItem('selectedAdmins', JSON.stringify(this.selectedAdmins));
                      } else {
                          //console.log('admin2');
                          this.selectedAdmins = JSON.parse(localStorage.getItem('selectedAdmins'));
                          this.selectedAdmins.every((value, index) => {
                              if (value == admin_user_id && index !== j) {
                                  // console.log('admin3');
                                  this.Adminmessage[j] = 'Admin already selected';
                                  this.registrationForm['controls']['addDynamicElement']['controls'][j]['controls'].admin_id.patchValue("");
                                  this.selectedAdmins[j] = "";
                                  localStorage.setItem('selectedAdmins', JSON.stringify(this.selectedAdmins));
                                  return false;
                              } else {
                                  //  console.log('admin4');
                                  this.selectedAdmins[j] = admin_user_id
                                  localStorage.setItem('selectedAdmins', JSON.stringify(this.selectedAdmins));
                              }
                              return true;
                          });

                      }
                  }
              }))
          }
          else{
            this.selectedAdmins[j] = admin_user_id
            localStorage.setItem('selectedAdmins', JSON.stringify(this.selectedAdmins));
          }



      } else {
          console.log('admin5');

          if (localStorage.getItem('selectedAdmins') !== null) {
              this.selectedAdmins = JSON.parse(localStorage.getItem('selectedAdmins'))
              this.selectedAdmins[j] = "";
              localStorage.setItem('selectedAdmins', JSON.stringify(this.selectedAdmins))
          }
      }

  }
  addAdmin() {
      this.CreateAdminComponent.addAdmin();
  }

  selectedStoreHistory() {
      if (localStorage.getItem('selectedStores') !== null) {
          this.selectedStores = JSON.parse(localStorage.getItem('selectedStores'));
      }
  }


  selectedAdminsHistory() {
      if (localStorage.getItem('selectedAdmins') !== null) {
          this.selectedAdmins = JSON.parse(localStorage.getItem('selectedAdmins'));
      }
  }
  allotHistoryClear() {
      localStorage.removeItem('selectedCompanies');
      localStorage.removeItem('selectedStores');
      localStorage.removeItem('selectedAdmins');
      localStorage.removeItem('unllotesLinces');
      localStorage.removeItem('selectedCompaniesAndstores');
      localStorage.removeItem('storeindex');
      localStorage.removeItem('companyindex');
  }

  /* ngOnDestroy(): void {
    this.allotHistoryClear();
  } */
}